import React, {useContext, createContext, useReducer} from 'react'

const RecurrenceStateContext = createContext()
const RecurrenceDispatchContext = createContext()

const initialState = {
  date_start: new Date(),
  date_end: new Date(),
  recurrenceType: 'none',
  weekDays: [0, 0, 0, 0, 0, 0, 0],
  frequencyDay: 'mon',
  frequency: '1st'
}

const recurrenceReducer = (state, action) => {
  switch (action.type) {
    case 'setValue':
      return {
        ...state,
        ...action.payload
      }
  }
}

const RecurrenceProvider = ({children}) => {
  const [state, dispatch] = useReducer(recurrenceReducer, initialState)

  return (
    <RecurrenceStateContext.Provider value={state}>
      <RecurrenceDispatchContext.Provider value={dispatch}>
        {children}
      </RecurrenceDispatchContext.Provider>
    </RecurrenceStateContext.Provider>
  )
}

const setRecurrenceValue = ({recurrenceDispatch, payload}) => {
  recurrenceDispatch({type: 'setValue', payload})
}

const useRecurrenceState = () => {
  const context = useContext(RecurrenceStateContext)

  if (!context) {
    throw new Error(
      'useRecurrenceState must be used within a RecurrenceProvider'
    )
  }

  return context
}

const useRecurrenceDispatch = () => {
  const context = useContext(RecurrenceDispatchContext)

  if (!context) {
    throw new Error(
      'useRecurrenceDispatch must be used within a RecurrenceProvider'
    )
  }

  return context
}

export {
  RecurrenceProvider,
  useRecurrenceState,
  useRecurrenceDispatch,
  setRecurrenceValue
}
